import TimelineStopGraphic, { STOP_TO_DO, StopColors, StopIcons, StopPositions } from './TimelineStopGraphic';
import { getDropoffLabels, getDropoffProperties, getPickupLabels, getPickupProperties } from './utils/deliveryUtils';
import './TimelineGraphic.scss';
interface TimelineGraphicProps {
  requester: string;
  pickups: string[];
  dropoffs: string[];
  currentStopIndex: number;
  isRequest?: boolean;
}

export default function TimelineGraphic(props: TimelineGraphicProps) {
  const { requester, pickups, dropoffs, currentStopIndex, isRequest } = props;

  const drawPickupGraphics = () => {
    return pickups.map((p, i) => {
      const properties = isRequest ? STOP_TO_DO : getPickupProperties(i, currentStopIndex, pickups);
      const label = getPickupLabels(i, currentStopIndex, pickups);
      return (
        <div className="timeline-graphic__stop" key={`pickup-${i}`}>
          <TimelineStopGraphic
            label={label.label}
            sublabel={label.sublabel}
            icon={properties.icon}
            position={StopPositions.Middle}
            color={properties.color}
          />
        </div>
      );
    });
  };

  const drawDropoffGraphics = () => {
    return dropoffs.map((d, i) => {
      const properties = isRequest ? STOP_TO_DO : getDropoffProperties(i, currentStopIndex, pickups.length, dropoffs);
      const label = getDropoffLabels(i, dropoffs);
      return (
        <div className="timeline-graphic__stop" key={`dropoff-${i}`}>
          <TimelineStopGraphic
            label={label.label}
            sublabel={label.sublabel}
            icon={properties.icon}
            position={i < dropoffs.length - 1 ? StopPositions.Middle : StopPositions.End}
            color={properties.color}
          />
        </div>
      );
    });
  };

  return (
    <div className="timeline-graphic">
      <TimelineStopGraphic
        label="Request"
        sublabel={requester}
        icon={isRequest ? StopIcons.LocationPin : StopIcons.Checkmark}
        position={StopPositions.Start}
        color={isRequest ? StopColors.Verdigris : StopColors.DarkGray}
      />
      {drawPickupGraphics()}
      {drawDropoffGraphics()}
    </div>
  );
}
